import * as React from "react";
import * as webHelpers from "../../../helpers/WebHelpers";
import {useNavigate} from 'react-router-dom';
import Logo from "../../../assets/logo.svg";

import { MdContactPhone, MdMenu } from 'react-icons/md';
import { MdClose } from 'react-icons/md';
import { MdMoving } from 'react-icons/md';
import { MdPeople } from 'react-icons/md';
import { MdLiveHelp } from 'react-icons/md';
import { MdLocalPhone } from 'react-icons/md';
import { MdPrivacyTip } from "react-icons/md";
import { MdLogout } from 'react-icons/md';


// import CloseIcon from "@mui/icons-material/Close";
// import PersonIcon from "@mui/icons-material/Person";
// import MovingIcon from "@mui/icons-material/Moving";
// import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from "../../../context/AuthContext.component";
import {useContext} from 'react';
import { Box, Button, Center, Divider, Flex, Spacer, Stack, Image, Menu, LinkBox, VStack, Text, Show, Hide, Drawer, useDisclosure, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, Heading, DrawerBody } from "@chakra-ui/react";
import CustomerDetails from "../CustomerDetails";
import { TrustPilotWidget } from "../trustpilot";

export enum PortalPageType {
    Customer,
    Quote
}

interface IPageContainerProps {
    pageTitle: string;
    type?: PortalPageType;
    children: React.ReactNode;
}

export function PageContainer(props: IPageContainerProps) {
    let navigate = useNavigate();
    let auth = useAuth();

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [partialNavBar, setPartialNavBar] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (props.type == PortalPageType.Quote) {
            setPartialNavBar(true);
        }
    }, [props.type]);

    const handleLogout = () => {
        if (props.type == PortalPageType.Quote) {
            navigate('/quote/signout')
        } else {
            navigate('/customer/signout');
        }
    }

    const handleContactClick = () => {
        window.open('https://www.able-group.co.uk/contact-us/?utm_source=customerportal&utm_medium=portal&utm_campaign=contact_us', '_blank', 'noopener,noreferrer');
    }

    const handleProgressClick = () => {
        navigate("/customer/overview/" + auth.user?.job_number);
    }

    const handleDetailsClick = () => {
        navigate("/customer/details/" + auth.user?.job_number);
    }

    const handleFaqClick = () => {
        navigate("/customer/faqs");
    }

    const handlePrivacyClick = () => {
        navigate("/customer/privacy");
    }

    return (
        <>
            <Flex direction='column' w='full' h='full' alignItems='center'>
                {/* Desktop nav bar */}
                <Box bg='var(--Able-blue)' h={28} p={6} borderBottom='4px' borderColor='var(--Able-yellow)' boxShadow='lg' zIndex={1} w='full'
                    display={{base: 'none', md: 'block'}}>
                    <Flex justify='center'>
                        <Flex alignItems='center' w={{ base: "100%", lg: "90%", "2xl": "80%"}}>
                            <img src={Logo} alt='Able-Group' width='125px'/>

                            {partialNavBar === false && auth.user !== null &&
                                <>
                                    <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' fontSize={16} onClick={handleProgressClick}>Job Progress</Button>
                                    <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' fontSize={16} onClick={handleDetailsClick}>My Details</Button>
                                </>
                            }

                            <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' fontSize={16} onClick={handleFaqClick}>FAQs</Button>
                            <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' fontSize={16} onClick={handlePrivacyClick}>Privacy</Button>
                            <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' fontSize={16} onClick={handleLogout}>Logout</Button>

                            <Spacer/>

                            <Flex direction='column' alignItems='end' fontSize='lg' color='white' pb={2}>
                                Contact Us:
                                <Flex>
                                    <MdLocalPhone style={{height: "2rem"}}/>
                                    <span style={{"paddingLeft": 5}} className="calltracks_customerservice">0330 042 1084</span>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Box>

                {/* Mobile bar and menu */}
                <Flex h={20} p={5} bg='var(--Able-blue)' fontSize={18} w='full' borderBottom='2px' boxShadow='lg' borderColor='var(--Able-yellow)' zIndex={1}
                    alignItems='center' justifyContent='space-between' display={{base: 'flex', md: 'none'}}>
                    <Image src={Logo} alt='Able-Group' width='100px' mt={8} zIndex={1}/>
                    <Flex onClick={onOpen} color='white'>
                        <MdMenu style={{ fontSize: "2.25rem" }}/>
                    </Flex>
                </Flex>

                <Flex
                    w={{ base: "100%", sm: "95%", "2xl": "80%" }}
                    backgroundColor="white"
                    p={2} pt={4} pb={4}
                    flexGrow={1}>
                    {props.children}
                </Flex>

                <Flex w='full' bg='var(--Able-blue)' justify='center'>
                    <Flex w={{ base: "100%", lg: "90%", "2xl": "70%"}} flexDir={{base: 'column', lg: 'row'}} justify='space-between' align='center' px={4} py={1}>
                        <Text textAlign='center' color='white' fontSize='xs'>Powered by Viabl Ltd, Company Registration Number: 11955942 (England & Wales), VAT Number: 626613543</Text>
                        <Text textAlign='center' color='white' fontSize='xs'>Copyright © www.able-group.co.uk 2025</Text>
                    </Flex>
                </Flex>
            </Flex>

            <Drawer isOpen={isOpen} onClose={onClose} placement='right' size='md'>
                <DrawerOverlay/>
                <DrawerContent bgGradient='linear(to-t, #3B8DAC, var(--Able-blue))'>
                    <DrawerCloseButton color='white'/>
                    <DrawerHeader borderBottomWidth={1} borderBottomColor='var(--Able-yellow)'>
                        <Flex align='center'>
                            <img src={Logo} alt='Able-Group' width='100px'/>
                            <Text fontSize={'3xl'} color='white' w='full' textAlign='center'>Able Group</Text>
                        </Flex>
                    </DrawerHeader>

                    <DrawerBody>
                        <Flex direction='column' alignItems='start' h='full'>
                            {partialNavBar === false && auth.user !== null &&
                                <>
                                    <Button color='white' _hover={{color: 'var(--Able-yellow)'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' onClick={handleProgressClick} leftIcon={<MdMoving style={{height: "2rem"}}/>} fontSize='xl'>Job Progress</Button>
                                    <Button color='white' _hover={{color: 'var(--Able-yellow)'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' onClick={handleDetailsClick} leftIcon={<MdPeople style={{height: "2rem"}}/>} fontSize='xl'>My Details</Button>
                                </>
                            }
                            <Button color='white' _hover={{color: 'var(--Able-yellow)'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' onClick={handleFaqClick} leftIcon={<MdLiveHelp style={{height: "2rem"}}/>} fontSize='xl'>FAQs</Button>
                            <Button color='white' _hover={{color: 'var(--Able-yellow)'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' onClick={handlePrivacyClick} leftIcon={<MdPrivacyTip style={{height: "2rem"}}/>} fontSize='xl'>Privacy</Button>
                            <Button color='white' _hover={{color: '#ffc107'}} _active={{bg: 'transparent'}} variant='ghost' fontWeight='normal' onClick={handleLogout} leftIcon={<MdLogout style={{height: "2rem"}}/>} fontSize='xl'>Logout</Button>

                            <Spacer/>

                            <Box fontSize='xl' color='white' mb={15}>
                                Contact Us:
                                <Flex>
                                    <MdLocalPhone style={{height: "2rem"}}/>
                                    <span style={{"paddingLeft": 10}} className="calltracks_customerservice">0330 042 1084</span>
                                </Flex>
                            </Box>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}